import { Flex, Circle } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { HEIGHT as HEADER_HEIGHT } from "app/components/Header";
import { WarningThreeIcon } from "ui/Icons/Icons";
import { BodyM, HeaderS } from "ui/Typography/Typography";

export function BatteryTasksLoadingError() {
  return (
    <Flex
      w="full"
      minH={`calc(100vh - ${HEADER_HEIGHT} - 2rem)`}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      gap="s200"
      bgColor="white"
    >
      <Circle bg="grey.150" size="168px">
        <WarningThreeIcon boxSize="120px" />
      </Circle>
      <HeaderS>
        <FormattedMessage id="pages.inventory.battery-count-page.placeholders.loading-error.title" />
      </HeaderS>
      <BodyM color="grey.800" maxW="293px">
        <FormattedMessage id="pages.inventory.battery-count-page.placeholders.loading-error.body" />
      </BodyM>
    </Flex>
  );
}
